import apiRequest from "../../utils/apiRequest";

const deleteTeamMemberApi = async (memberId) => {
    return await apiRequest(`member/${memberId}`, "delete");
};

export default deleteTeamMemberApi;
